// each page maintain an active error list (which come from yup)
// containg the error message and the component name the error refers to

import { object as yupObject, array as yupArray, string, number, date, InferType, mixed, addMethod } from 'yup';

export function getErrorListFromYupError(yupError) {
    const errors = JSON.parse(JSON.stringify(yupError))
    //console.log(errors)
    return errors.inner.map(error => {
                             return {fieldName: error.path, message: error.message, params: error.params}                            
    })

}

export function getErrorMessage(errorList, fieldName) {
    if (errorList === undefined) return undefined;
    
    const matched = errorList.find(e => e.fieldName === fieldName)

    if (matched) return matched.message
    else return undefined
}

export function getErrorMessageForArray(errorList, fieldName, index) {
  if (errorList === undefined) return undefined;
  
  const matched = errorList.find(e => e.fieldName === fieldName)
  if (matched) {
    //console.log(matched.params.indexes.includes(index))
    if (matched.params.indexes.includes(index)) return matched.message
    else return undefined
  }

  return undefined
}


export const snippetDataTimerValidationSchema = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    href: string().required("Required field").url("Must be a valid url"),
    
    timerSettings: string().test(
      'validateInputDateFormat',
      '',
      (value, context) => {
        const valueJson = JSON.parse(value)
        if (!valueJson.timerType.startsWith('custom')) return true;

        if (valueJson.inputDateFormat === undefined || valueJson.inputDateFormat === '')
          return context.createError({path: 'timerSettingsInputDateFormat', message: 'Required field'});
        else return true;
      }
    ).test(
      'validateHrefAfterExpiry',
      '',
      (value, context) => {
        const valueJson = JSON.parse(value)
        const urlValidator = string().url();
        const isValidUrl = urlValidator.isValidSync(valueJson.hrefAfterExpiry)
        if (isValidUrl) return true;
        else return context.createError({path: 'timerSettingsHrefAfterExpiry', message: 'Must be a valid url'});

      }
    )
    
    /*timerSettings: yupObject({
      inputDateFormat: string().required("Required field"),
    })*/
  });

export const snippetDataValidationSchemaBase = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    href: string().required("Required field").url("Must be a valid url"),
    snippetSettings: yupObject().nullable().test(
      'fallbackImageModeAtLeastOneCheckbox',
      '',
      (value, context) => {
        if (value?.useFallback && (value?.fallbackMode === 'image' || value?.fallbackMode === 'mixed')) {
          const conditions = value.fallback.image
          if (conditions.isEmpty || conditions.isLonger || conditions.isShorter) return true
          else return context.createError({path: 'fallbackImageModeAtLeastOneCheckbox', message: 'You must tick at least one box'});
        }
        else return true
      }
    ).test(
      'fallbackParametersModeAtLeastOneCheckbox',
      '',
      (value, context) => {
        //console.log(value)
        if (value?.useFallback && (value?.fallbackMode === 'parameters' || value?.fallbackMode === 'mixed')) {
          const conditions = value.fallback.parameters
          if (conditions.isEmpty || conditions.isLonger || conditions.isShorter) return true
          else return context.createError({path: 'fallbackParametersModeAtLeastOneCheckbox', message: 'You must tick at least one box'});
        }
        else return true
      }
    ).test(
      'fallbackImageModeImgB64',
      '',
      (value, context) => {
        if (value?.useFallback && (value?.fallbackMode === 'image' || value?.fallbackMode === 'mixed')) {
          if (value.fallback.image.imgB64 === '') return context.createError({path: 'fallbackImageModeImgB64', message: 'You must upload an image'});
          else return true
        }
        else return true
      }
    )
  });

  export const snippetDataValidationSchemaGenerator = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    href: string().required("Required field"),
  });

  export const snippetDataValidationSchemaOSTracker = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),

    snippetSettings: yupObject().test(
      'validateDefaultHref',
      '',
      (value, context) => {
        //console.log(value)
        if (value.Other.href && value.Other.href.length > 0) return true;
        else return context.createError({path: 'snippetSettingsDefaultHref', message: 'Required field'});

      }
    ).test(
      'validateDefaultImg',
      '',
      (value, context) => {
        //console.log(value)
        if (value.Other.imgB64 && value.Other.imgB64.length > 0) return true;
        else return context.createError({path: 'snippetSettingsDefaultImg', message: 'Required'});

      }
    )
  });

  export const snippetDataValidationSchemaScratch = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    snippetSettings: yupObject().test(
      'coverImgUploaded',
      '',
      (value, context) => {
        //console.log(value)
        if (value.teaserImgB64.length > 0) return true;
        else return context.createError({path: 'snippetSettingsCoverImg', message: 'You must upload a cover image'});

      }
    ).test(
      'revealImgUploaded',
      '',
      (value, context) => {
        //console.log(value)
        const errors = []
        value.revealImages.forEach((img, index) => {if ((img.isTag == undefined || img.isTag === false) && img.imgB64.length === 0) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'snippetSettingsRevealImg', message: 'You must upload a reveal image', params: {indexes: errors}});
        else return true;
      }
    ).test(
      'revealTextImage',
      '',
      (value, context) => {
        //console.log(value)
        const errors = []
        value.revealImages.forEach((img, index) => {if (img.isTag === true && !img.snippetId > 0) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'snippetSettingsRevealTextImage', message: 'You must select an Element', params: {indexes: errors}});
        else return true;
      }
    ).test(
      'revealHref',
      '',
      (value, context) => {
        //console.log(value)
        const errors = []
        value.revealImages.forEach((img, index) => {if ((img.isTag == undefined || img.isTag === false) && img.href.length === 0) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'snippetSettingsRevealHref', message: 'Href is required', params: {indexes: errors}});
        else return true;
      }
    )

  });

  export const snippetDataValidationSchemaSpinningWheel = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    
    wheelSettings: yupObject().test(
      'slicesHref',
      '',
      (value, context) => {
        const errors = []
        value.slices.forEach((slice, index) => {if (slice.href.length === 0 && !slice.notUsed) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'wheelSettingsSlicesHref', message: 'Href is required', params: {indexes: errors}});
        else return true;
      }
    ).test(
      'slicesMapping',
      '',
      (value, context) => {
        return true;
        /*
        //not needed anymore
        const errors = []
        value.slices.forEach((slice, index) => {if (slice.mapping.length === 0 && !slice.notUsed) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'wheelSettingsSlicesMapping', message: 'Mapping is required', params: {indexes: errors}});
        else return true;
        */
      }
    ).test(
      'slicesDoNotUse',
      '',
      (value, context) => {
        //we check that not all the NoUsed tickboxes are checked
        let foundInUse = false;
        value.slices.forEach((slice, index) => {if (!slice.notUsed) foundInUse = true})
        if (!foundInUse) return context.createError({path: 'wheelSettingsSlicesDoNotUse', message: 'You need to use at least one slice',});
        else return true;
      }
    )

  });

  export const snippetDataValidationSchemaWeatherForecasts = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    href: string().required("Required field").url("Must be a valid url"),
    snippetSettings: yupObject().test(
      'defaultImage',
      '',
      (value, context) => {
        if (value === undefined || value.defaultImage === undefined) return context.createError({path: 'defaultImage', message: 'You must upload a default image'})

        const errors = []
        if (value.defaultImage.length === 0) return context.createError({path: 'defaultImage', message: 'You must upload a default image'});
        else return true;
      }
    )
  });


  export const weatherCollectionValidationSchema = yupObject({
    collectionName: string().required("Provide a value for collection name"),
    
    
    collection: yupArray().test(
      'isDefaultSet',
      '',
      (value, context) => {
        let found = false
        value.forEach((iconGroup, index) => {if (iconGroup.isDefault) found = true})
        if (!found) return context.createError({path: 'isDefaultSet', message: 'Set a default group'});
        else return true;
      }
    ).test(
      'areIconsSet',
      '',
      (value, context) => {
        let allSet = true
        value.forEach((iconGroup, index) => {if (iconGroup.iconDayDataURL.length === 0) allSet = false})
        if (!allSet) return context.createError({path: 'areIconsSet', message: 'Upload an image for all the Day Versions'});
        else return true;
      }
    )
  });

  export const snippetDataValidationSchemaTimedImages = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    snippetSettings: yupObject().test(
      'timelineImages',
      '',
      (value, context) => {
        if (value === undefined || value === null ) return context.createError({path: 'timelineImages', message: 'An image is required', params: {indexes: [0,1]}})
        const errors = []
        value.assets.forEach((asset, index) => {if (asset.img.length === 0) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'timelineImages', message: 'An image is required', params: {indexes: errors}});
        else return true;

      }
    ).test(
      'timelineHref',
      '',
      (value, context) => {
        if (value === undefined || value === null ) return context.createError({path: 'timelineHref', message: 'Href is required', params: {indexes: [0,1]}})
        const errors = []
        value.assets.forEach((asset, index) => {if (asset.href.length === 0) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'timelineHref', message: 'Href is required', params: {indexes: errors}});
        else return true;

      }
    )
  });
  export const dataFunctionsValidationSchema = yupObject({
    functionPrettyName: string().required("Required field"),
    description: string().required("Required field"),
    metadata: yupObject().test(
      'functionParameters',
      '',
      (value, context) => {
        //console.log(value)
        
        
        if (value.parameters === undefined || value.parameters.length === 0 ) return true
        const errors = []
        value.parameters.forEach((p, index) => {if (p.name.length === 0) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'functionParameters', message: 'Parameter name is required', params: {indexes: errors}});
        else return true;
        
      }
    )
  });
  export const snippetDataValidationSchemaVariantViewer_snippetSettings = yupObject({
    snippetSettings: yupObject().test(
      'bindings',
      '',
      (value, context) => {
        const errors = []
        value.variantsBindings.forEach((vb, index) => {if (vb.length === 0) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'snippetSettingsVariantsBindings', message: 'Binding is required', params: {indexes: errors}});
        else return true;
      }
    )

  });


  export const snippetDataValidationSchemaSlidingPuzzle = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    snippetSettings: yupObject().test(
      'puzzleImgUploaded',
      '',
      (value, context) => {
        //console.log(value)
        if (value.puzzleImgB64.length > 0) return true;
        else return context.createError({path: 'snippetSettingsPuzzleImg', message: 'You must upload a puzzle image'});

      }
    )

  });

  export const snippetDataValidationSchemaMemoryCards = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    snippetSettings: yupObject().test(
      'images',
      '',
      (value, context) => {
        //console.log(value)
        const errors = []
        value.cardImages.forEach((img, index) => {if (img.imgB64 != undefined && img.imgB64.length === 0 && img.tagId === undefined) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'snippetSettingsImages', message: 'You must upload an image', params: {indexes: errors}});
        else return true;
      }
    ),

  });

  export const webPageSettingsValidationSchemaMemoryCards = yupObject({
    href: string().required("Required field"),
    templatePropValuesCollection: yupArray().test(
        'expirySettings',
        '',
        (value, context) => {
          //console.log(value)
          const errors = []
          value.forEach((kvp, index) => {
                                    if (kvp.propName === 'expired-msg' && kvp.propValue.length === 0) errors.push(kvp.propName)
                                    if (kvp.propName === 'expired-href' && kvp.propValue.length === 0) errors.push(kvp.propName)
                                    if (kvp.propName === 'expired-button-title' && kvp.propValue.length === 0) errors.push(kvp.propName)
                                    })
          if (errors.length > 0) return context.createError({path: 'expirySettings', message: 'Required field', params: {indexes: errors}});
          else return true;
        }
      ),

  });
export const snippetDataChartsValidationSchema = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    href: string().required("Required field").url("Must be a valid url"),
        
  });
export const snippetBarcodesValidationSchema = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    href: string().required("Required field"),
        
  });

  export const snippetDataValidationSchemaImageOptimiser = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    snippetSettings: yupObject().test(
      'images',
      '',
      (value, context) => {
        //console.log(value)
        const errors = []
        value.images.forEach((img, index) => {if (img.imgB64 != undefined && img.imgB64.length === 0) errors.push(index)})
        //console.log(errors) 
        if (errors.length > 0) return context.createError({path: 'snippetSettingsImages', message: 'You must upload an image', params: {indexes: errors}});
        else return true;
      }
    ).test(
      'imagesCount',
      '',
      (value, context) => {
        if (value.images.length < 2) return context.createError({path: 'snippetSettingsImagesCount', message: 'Please upload at least two images',});
        else return true;
      }
    ),

  });

  export const snippetDataValidationSchemaGuessWord = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    snippetSettings: yupObject().test(
      'databindList',
      '',
      (value, context) => {
        //console.log(value)
        if (value.databind.databindType === 'list') {
          if (value.databind.list == null || value.databind.list.length === 0) return context.createError({path: 'snippetDatabindList', message: 'You must insert at least one word'});
          for (const word of value.databind.list.split('\n')) {
            if (word === '') continue
            if (word.length <= 2 || word.length > 8) return context.createError({path: 'snippetDatabindList', message: 'For a better experience on all screens please use words between 3 and 8 character long'});
          }
          return true
        }
        else return true
        //return true;
      }
    ).test(
      'databindUrlDefault',
      '',
      (value, context) => {
        //console.log(value)
        if (value.databind.databindType === 'url') {
          if (value.databind.urlDefaultWord == null || value.databind.urlDefaultWord.length === 0) return context.createError({path: 'snippetDatabindUrlDefault', message: 'The default word is required'});
        }
        return true
      }
    ),

  });
  export const snippetDataValidationSchemaOfferBroker = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    snippetSettings: yupObject().test(
      'images',
      '',
      (value, context) => {
        //console.log(value)
        const errors = []
        value.images.forEach((img, index) => {if (img.imgB64 != undefined && img.imgB64.length === 0) errors.push(index)})
        //console.log(errors) 
        if (errors.length > 0) return context.createError({path: 'snippetSettingsImages', message: 'You must upload an image', params: {indexes: errors}});
        else return true;
      }
    ).test(
      'hrefs',
      '',
      (value, context) => {
        const errors = []
        value.images.forEach((img, index) => {if (img.href.length === 0) errors.push(index)})
        //console.log(errors) 
        if (errors.length > 0) return context.createError({path: 'snippetSettingsHrefs', message: 'Href is required', params: {indexes: errors}});
        else return true;
      }
    ),

  });
  export const snippetDataValidationSchemaConditionsManager = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    snippetSettings: yupObject().test(
      'default',
      '',
      (value, context) => {
        if (value.default.type === 'showStatic') {
          if (value.default.imgB64 === '') return context.createError({path: 'snippetSettingsDefaultImage', message: 'You must upload an image', });
        }
        if (value.default.type === 'showSnippet') {
          if (!value.default.snippetId > 0) return context.createError({path: 'snippetSettingsDefaultSnippetId', message: 'You must select an element', });
        }
        return true
      }
    ).test(
      'defaultHref',
      '',
      (value, context) => {
        if (value.default.type === 'showStatic') {
          if (value.default.href == undefined || value.default.href === '') return context.createError({path: 'snippetSettingsDefaultHref', message: 'Required field', });
        }
        return true
      }
    ).test(
      'condBlocks',
      '',
      (value, context) => {
        //console.log(value)
        const errors = []
        value.rules.forEach((r, index) => {if (r.conditionBlocks != undefined && r.conditionBlocks.length === 0) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'snippetSettingsConditionBlocks', message: 'You must define a condition', params: {indexes: errors}});
        else return true;
      }
    ).test(
      'condEditMode',
      '',
      (value, context) => {
        //console.log(value)
        const errors = []
        value.rules.forEach((r, index) => {
          r.conditionBlocks.forEach((c, cIndex) => {
            if (c.editMode) errors.push(index)
          })
        })
        //console.log(errors) 
        if (errors.length > 0) return context.createError({path: 'snippetSettingsConditionsEditMode', message: 'You must confirm the condition', params: {indexes: errors}});
        else return true;
      }
    ).test(
      'condBlocksValueParamName',
      '',
      (value, context) => {
        //console.log(value)
        const errors = []
        value.rules.forEach((r, index) => {
          r.conditionBlocks.forEach((c, cIndex) => {
            if (c.type.startsWith('condition.')) {
              const codeValue = c.code[2]
              if (codeValue && typeof codeValue === "object" && Object.hasOwn(codeValue, 'useUrlParam')) {
                if (codeValue.useUrlParam && codeValue.urlParam === '') errors.push(index)
              }
              
            }
          })
        })
        //console.log(errors) 
        if (errors.length > 0) return context.createError({path: 'snippetSettingsConditionsBlocksValueParamName', message: 'Required', params: {indexes: errors}});
        else return true;
      }
    ).test(
      'condBlocksUrlParamName',
      '',
      (value, context) => {
        //console.log(value)
        const errors = []
        value.rules.forEach((r, index) => {
          r.conditionBlocks.forEach((c, cIndex) => {
            if (c.type === 'condition.url' && c.code[0] === '{%url()%}') errors.push(index)
          })
        })
        //console.log(errors) 
        if (errors.length > 0) return context.createError({path: 'snippetSettingsConditionsBlocksUrlParamName', message: 'Required', params: {indexes: errors}});
        else return true;
      }
    ).test(
      'actionsStaticImage',
      '',
      (value, context) => {
        //console.log(value)
        const errors = []
        value.rules.forEach((r, index) => {
          if (r.action.type === 'showStatic') {
            if (r.action.imgB64 === '') errors.push(index)
          }
        })
        //console.log(errors) 
        if (errors.length > 0) return context.createError({path: 'snippetSettingsActionsStaticImage', message: 'You must upload an image', params: {indexes: errors}});
        else return true;
      }
    ).test(
      'actionsStaticHref',
      '',
      (value, context) => {
        //console.log(value)
        const errors = []
        value.rules.forEach((r, index) => {
          if (r.action.type === 'showStatic') {
            if (r.action.href === '') errors.push(index)
          }
        })
        //console.log(errors) 
        if (errors.length > 0) return context.createError({path: 'snippetSettingsActionsStaticHref', message: 'Required field', params: {indexes: errors}});
        else return true;
      }
    ).test(
      'actionsNoSnippet',
      '',
      (value, context) => {
        //console.log(value)
        const errors = []
        value.rules.forEach((r, index) => {
          if (r.action.type === 'showSnippet') {
            if (!r.action.snippetId > 0) errors.push(index)
          }
        })
        //console.log(errors) 
        if (errors.length > 0) return context.createError({path: 'snippetSettingsActionsNoSnippet', message: 'Select an Element', params: {indexes: errors}});
        else return true;
      }
    ), 
    
  });
  export const nearestStoresFileValidationSchema = yupObject({
      name: string().required("Required field"),
      file: string().required("Upload a file"),
      columnMapping: yupObject().test(
      'default',
      '',
      (value, context) => {
        let storeId_found = false
        let lat_found = false
        let long_found = false
        //console.log(value)
        for (const key of Object.keys(value)) {
          if (value[key] === 'storeId') storeId_found = true
          if (value[key] === 'latitude') lat_found = true
          if (value[key] === 'longitude') long_found = true
        }
        if (!storeId_found || !lat_found || !long_found) {
          let msg = ""
          if (!storeId_found) msg += '||storeId'
          if (!lat_found) msg += '||latitude'
          if (!long_found) msg += '||longitude'
          return context.createError({path: 'columnMapping', message: msg, });
        }
        return true
      }
    )
  });
  export const snippetDataValidationSchemaNearestStore = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    //href: string().required("Required field"),
    snippetSettings: yupObject().test(
    'snippetSettingsFallbackImage',
    '',
    (value, context) => {
      if (value == undefined || value.fallbackImage.length === 0)
        return context.createError({path: 'fallbackImage', message: 'Upload a fallback image', });
      else 
        return true
    }).test(
    'snippetSettingsFallbackHref',
    '',
    (value, context) => {
      if (value == undefined || value.fallbackHref.length === 0) {
        return context.createError({path: 'fallbackHref', message: 'Required field', });
      }
      else 
        return true
    }).test(
    'snippetSettingsHref',
    '',
    (value, context) => {
      if (value == undefined || value.href.length === 0) {
        if (value == undefined || value.hrefMode === 'static') return context.createError({path: 'href', message: 'Required field', });
        else return true
      }
      else 
        return true
    })

  });

  
  addMethod(string, 'CC_relaxedUrl', function (errorMessage = 'Invalid URL') {
    return this.test('is-relaxed-url', errorMessage, value => {
      if (!value) return false;
  
      try {
        const url = new URL(value);
        const isValidProtocol = url.protocol === 'http:' || url.protocol === 'https:';
        if (!isValidProtocol) return false;
  
        const allowedChars = '{}$';
        const query = url.search;
  
        const invalidChars = [...query].filter(char => {
          const code = char.charCodeAt(0);
          return code < 32 || (code >= 127 && !allowedChars.includes(char));
        });
  
        return invalidChars.length === 0;
      } catch {
        return false;
      }
    });
  });